import { useTranslation } from "react-i18next";

export default function MPFServicesSection() {
  const { t } = useTranslation();

  const steps = [
    { num: "01", titleKey: "mpf_step1_title", descKey: "mpf_step1_desc" },
    { num: "02", titleKey: "mpf_step2_title", descKey: "mpf_step2_desc" },
    { num: "03", titleKey: "mpf_step3_title", descKey: "mpf_step3_desc" },
    { num: "04", titleKey: "mpf_step4_title", descKey: "mpf_step4_desc" },
  ];

  const highlights = [
    { icon: "ri-shield-star-line", textKey: "mpf_h1" },
    { icon: "ri-time-line", textKey: "mpf_h2" },
    { icon: "ri-team-line", textKey: "mpf_h3" },
    { icon: "ri-customer-service-2-line", textKey: "mpf_h4" },
  ];

  return (
    <section id="mpf-services" className="py-24 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: image + highlights */}
          <div className="flex flex-col gap-6">
            <div className="rounded-2xl overflow-hidden h-[320px]">
              <img
                src="https://public.readdy.ai/ai/img_res/70bfd874395b3073490c7ab3406be8c4.jpg"
                alt="MPF Services"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {highlights.map((h) => (
                <div key={h.textKey} className="flex items-center gap-3 bg-white border border-gray-100 rounded-xl px-4 py-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#FAE8DF] flex-shrink-0">
                    <i className={`${h.icon} text-[#D4927A] text-lg`} />
                  </div>
                  <span className="text-[#1C2331] text-xs font-medium leading-snug">{t(h.textKey)}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: content */}
          <div>
            <span className="text-[#D4927A] text-sm font-semibold tracking-widest uppercase">{t("mpf_tag")}</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1C2331] mt-2 mb-4 leading-tight">
              {t("mpf_heading")}
            </h2>
            <p className="text-[#6B7280] text-sm leading-relaxed mb-8">
              {t("mpf_desc")}
            </p>

            {/* Steps */}
            <div className="space-y-5">
              {steps.map((step, idx) => (
                <div key={step.num} className="flex gap-5 items-start">
                  <div className="flex-shrink-0 flex flex-col items-center">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1C2331] text-[#F2C4B5] font-bold text-sm">
                      {step.num}
                    </div>
                    {idx < steps.length - 1 && <div className="w-px h-8 bg-gray-200 mt-1" />}
                  </div>
                  <div className="pt-1.5">
                    <h3 className="font-bold text-[#1C2331] text-sm mb-1">{t(step.titleKey)}</h3>
                    <p className="text-[#6B7280] text-xs leading-relaxed">{t(step.descKey)}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
              className="mt-8 flex items-center gap-2 bg-[#D4927A] hover:bg-[#C07F6A] text-white font-semibold px-7 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              {t("mpf_cta")} <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
